export default "__VITE_ASSET__1mkSgVfi__"